import { render, staticRenderFns } from "./ProjectListView.vue?vue&type=template&id=0b7e4668&"
import script from "./ProjectListView.vue?vue&type=script&lang=js&"
export * from "./ProjectListView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0b7e4668')) {
      api.createRecord('0b7e4668', component.options)
    } else {
      api.reload('0b7e4668', component.options)
    }
    module.hot.accept("./ProjectListView.vue?vue&type=template&id=0b7e4668&", function () {
      api.rerender('0b7e4668', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/portfolio/projects/ProjectListView.vue"
export default component.exports